export const ProductInfo = {
  VIEW_3K: { id: 1, price: 49000 },
  VIEW_8K: { id: 2, price: 99000 },
  VIEW_16K: { id: 3, price: 199000 },
};

export enum Gender {
  ALL = 0,
  MALE = 1,
  FEMALE = 2,
}

//https://zdoc.zing.vn/pages/viewpage.action?pageId=135901214
//age 55+ trong lib jzfeed-ads-thrift9 mapping khác với trong docs
export enum AgeRange {
  AGE_ALL = 0,
  // AGE_0_17 = 1,
  AGE_18_24 = 2,
  AGE_25_34 = 3,
  AGE_35_44 = 4,
  AGE_45_54 = 5,
  // AGE_55_64 = 6,
  AGE_55P = 6,
  // AGE_65P = 8,
}

export enum TLocation {
  ALL = 0,
  AN_GIANG = 1,
  BEN_TRE = 3,
  CAO_BANG = 5,
  DONG_THAP = 9,
  HAI_PHONG = 13,
  TP_HO_CHI_MINH = 20,
  KIEN_GIANG = 21,
  LAM_DONG = 23,
  LONG_AN = 24,
  QUANG_NINH = 30,
  SON_LA = 32,
  TAY_NINH = 33,
  THANH_HOA = 34,
  THAI_BINH = 35,
  TIEN_GIANG = 37,
  LANG_SON = 39,
  DONG_NAI = 43,
  HA_NOI = 44,
  BA_RIA_VUNG_TAU = 45,
  BINH_DINH = 46,
  BINH_THUAN = 47,
  GIA_LAI = 49,
  HA_GIANG = 50,
  HA_TINH = 52,
  HOA_BINH = 53,
  KHANH_HOA = 54,
  KON_TUM = 55,
  NGHE_AN = 58,
  NINH_BINH = 59,
  NINH_THUAN = 60,
  PHU_YEN = 61,
  QUANG_BINH = 62,
  QUANG_NGAI = 63,
  QUANG_TRI = 64,
  SOC_TRANG = 65,
  THUA_THIEN_HUE = 66,
  TRA_VINH = 67,
  TUYEN_QUANG = 68,
  VINH_LONG = 69,
  YEN_BAI = 70,
  BAC_GIANG = 71,
  BAC_KAN = 72,
  BAC_LIEU = 73,
  BAC_NINH = 74,
  BINH_DUONG = 75,
  BINH_PHUOC = 76,
  CA_MAU = 77,
  DA_NANG = 78,
  HAI_DUONG = 79,
  HA_NAM = 80,
  HUNG_YEN = 81,
  NAM_DINH = 82,
  PHU_THO = 83,
  QUANG_NAM = 84,
  THAI_NGUYEN = 85,
  VINH_PHUC = 86,
  CAN_THO = 87,
  DAK_LAK = 88,
  LAI_CHAU = 89,
  LAO_CAI = 90,
  DAK_NONG = 91,
  DIEN_BIEN = 92,
  HAU_GIANG = 93,
}
